module.exports = __webpack_public_path__ + "TB_Warning_Ambience_A.wav.52ef0b56.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/warning/TB_Warning_Ambience_A.wav.mp3
// module id = 508
// module chunks = 0